import React from "react";

export default React.lazy(
  () => import(/* webpackChunkName: "parent-dashboard" */ "./parent/Route")
);
